<template>
  <b-row id="breadcrumbs">
    <b-col>
      <b-button-group>
        <b-button
          v-for="(crumb, index) in crumbs"
          :key="index"
          @click="$parent.updateScreen(crumb.screen)"
        >
          <b-icon v-if="crumb.icon" :icon="crumb.icon" />
          {{ crumb.name }}
        </b-button>
      </b-button-group>
    </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
.btn-group {
  margin: 10px 0;
  button.btn.btn-secondary {
    margin-right: 2px;
  }
}
</style>

<script>
import _ from 'lodash';

export default {
  name: 'Breadcrumbs',
  props: {
    currentScreen: {
      type: String,
      default: 'enterKey',
    },
  },
  computed: {
    crumbs() {
      const vm = this;
      const crumbs = [
        { name: 'start', icon: 'house-fill', screen: 'enterKey' },
        { name: 'services', icon: 'list', screen: 'services' },
        { name: 'tables', icon: 'table', screen: 'tables' },
      ];

      if (vm.currentScreen === 'enterKey' || vm.currentScreen === 'services') {
        return _.slice(crumbs, 0, 1);
      }
      if (vm.currentScreen === 'tables') {
        return _.slice(crumbs, 0, 2);
      }
      return crumbs;
    },
  },
};
</script>
